export const beritaData = [
  {
    id: 1,
    image: "/images/asset/gambar-1.svg",
    title: "Sosialisasi Masa Persiapan Pensiun kepada Karyawan PT. Toyota Astra Motor",
    summary:
      "Sosialisasi Masa Persiapan Pensiun kepada karyawan PT. Toyota Astra Motor, para pensiunan PT. Toyota Astra hadir dalam sesi sosialisasi persiapan memasuki masa...",
    date: "6 Agustus 2024",
    content: `Sosialisasi Masa Persiapan Pensiun kepada karyawan PT. Toyota Astra Motor.

Para Pengurus Dana Pensiun Toyota Astra hadir dalam sesi sosialisasi persiapan memasuki masa pensiun. Acara ini bertujuan untuk memberikan pemahaman dan persiapan yang matang kepada para karyawan menjelang masa purnabakti.

Acara tersebut diselenggarakan di Jakarta pada tanggal 6 Agustus 2024.`,
    galeri: [
      "/images/asset/galeri3.svg",
      "/images/asset/galeri1.svg",
      "/images/asset/galeri2.svg",
    ],
    link: "/berita/1",
  },
  {
    id: 2,
    image: "/images/asset/gambar-2.svg",
    title: "(FGD) Mengupas Tuntas POJK 27/2023...",
    summary:
      "Menghadiri diskusi dan tanya jawab Dana Pensiun bersama dengan pihak otoritas peraturan perbankan dan para pengurus Dana Pensiun secara proaktif menghadapi...",
    date: "22 Juli 2024",
    content: `(FGD) Mengupas Tuntas POJK 27/2023 tentang Pengelolaan Dana Pensiun.

Dalam forum ini, para peserta membahas lebih dalam peraturan terbaru mengenai pengelolaan dana pensiun, termasuk peran serta tanggung jawab pengurus dan pengawas.

Diskusi dilakukan secara interaktif bersama narasumber dari OJK.`,
    galeri: [
      "/images/asset/galeri3.svg",
      "/images/asset/galeri1.svg",
      "/images/asset/galeri2.svg",
    ],
    link: "/berita/2",
  },
  {
    id: 3,
    image: "/images/asset/gambar-3.svg",
    title: "Sosialisasi Dana Pensiun Kepada Karyawan...",
    summary:
      "Para Pengurus Dana Pensiun mengadakan sosialisasi Dana Pensiun kepada para pegawai SPSI, di Auditorium Plant Sunter II...",
    date: "14 Juni 2024",
    content: `Sosialisasi Dana Pensiun Kepada Karyawan SPSI.

Para pengurus Dana Pensiun menyampaikan informasi penting mengenai manfaat, mekanisme pencairan, serta hak dan kewajiban peserta pensiun. 

Kegiatan ini berlangsung di Auditorium Plant Sunter II dan diikuti secara antusias oleh para peserta.`,
    galeri: [
      "/images/asset/galeri3.svg",
      "/images/asset/galeri1.svg",
      "/images/asset/galeri2.svg",
    ],
    link: "/berita/3",
  },
];
